// extracted by mini-css-extract-plugin
module.exports = {"container":"iOloMqpXgcETGYqgpgRfB","domain":"-iROtochRF2c1HdDzTwh","input":"_1q4rXLHSBW89RUUW8kvqUa","icon":"_2XQ7V1NcVa6INd4SFc2zg8"};